export default __webpack_public_path__ + "static/22-3cf0a2852669b409bfedd66b696dca1d.png";